import { debounce } from '../../utils/debounce'
import { BaseComponent } from '../../components/base-component'
import { $el, $list } from 'src/scripts/utils/utils'
import { isMobile } from 'src/scripts/utils/check-media'

const CONTAINER_SELECTOR = '[data-scrolling-text-container]'
const LINE_SELECTOR = 'scrolling-text-line'
const CROSSED_LAYOUT_SELECTOR = '.block-wrapper--crossed'

export class ScrollingText extends BaseComponent {
  resizeObserver: ResizeObserver
  isCrossed: boolean
  isInitialMobile: boolean
  heightPercent: number
  width: number

  mountComponent(): void {
    const container = $el(CONTAINER_SELECTOR, this)

    this.width = this.offsetWidth
    this.isInitialMobile = isMobile()

    this.isCrossed = Boolean($el(CROSSED_LAYOUT_SELECTOR, this))

    this.setHeight()

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(container)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  calcHeight = (): number => {
    const lines = $list(LINE_SELECTOR, this)
    let heightToSet: number

    const firstLineRect = lines[0].getBoundingClientRect()

    if (lines.length > 1) {
      const coordsTop: number[] = []
      const coordsBottom: number[] = []

      const lastLineRect = lines[lines.length - 1].getBoundingClientRect()

      coordsTop.push(firstLineRect.top)
      coordsTop.push(lastLineRect.top)
      coordsBottom.push(firstLineRect.bottom)
      coordsBottom.push(lastLineRect.bottom)

      heightToSet =
        coordsBottom.sort((a, b) => b - a)[0] -
        coordsTop.sort((a, b) => a - b)[0]
    } else {
      heightToSet = firstLineRect.height
    }

    this.heightPercent = heightToSet / this.offsetWidth

    return heightToSet
  }

  setHeight = (value?: number): void => {
    this.style.setProperty(
      '--gsc-section-height',
      `${value ?? this.calcHeight()}px`,
    )
  }

  handleResize = debounce((): void => {
    if (this.width === this.offsetWidth) {
      return
    }

    if (this.isCrossed) {
      const h = isMobile()
        ? this.heightPercent * this.offsetWidth +
          (this.isInitialMobile ? 0 : 30)
        : this.heightPercent * this.offsetWidth -
          (this.isInitialMobile ? 80 : 0)

      this.setHeight(h)
    } else {
      this.setHeight()
    }

    this.width = this.offsetWidth
  }, 200)
}
